import { ProfileService } from 'src/app/_services/profile.service';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TimelineService } from 'src/app/_services/timeline.service';
import { BehaviorSubject } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.css']
})
export class TimelineComponent implements OnInit {
  @Output() resetChanges = new EventEmitter<boolean>();
  @Output() year = new EventEmitter<string>();
  @Output() month = new EventEmitter<string>();
  @Output() start_week = new EventEmitter<string>();
  @Output() end_week = new EventEmitter<string>();
  @Input() isClearBS = new BehaviorSubject<boolean>(true);
  @Input('chosenUser') chosenUser: any;

  months = [
    { value: 1, viewValue: 'Gen' },
    { value: 2, viewValue: 'Feb' },
    { value: 3, viewValue: 'Mar' },
    { value: 4, viewValue: 'Apr' },
    { value: 5, viewValue: 'Mag' },
    { value: 6, viewValue: 'Giu' },
    { value: 7, viewValue: 'Lug' },
    { value: 8, viewValue: 'Ago' },
    { value: 9, viewValue: 'Set' },
    { value: 10, viewValue: 'Ott' },
    { value: 11, viewValue: 'Nov' },
    { value: 12, viewValue: 'Dic' }
  ];

  years: any;

  userMonth: number;
  userYear: number;

  currentMonth: any;
  selectedMonth: any;
  selectedMonthName: any;

  currentYear: any;
  selectedYear: any;

  week: any;
  data: any = [];
  user_create: any;
  profileData: any;

  enableDragDrop: boolean = true;

  constructor(
    private readonly timelineService: TimelineService,
    private readonly router: Router,
    private readonly profileService: ProfileService
  ) {}

  async ngOnInit(): Promise<void> {
    this.profileData = await this.profileService.getUserRoleAsync();
    this.current_date();
    this.check_path();
  }

  ngOnChanges(): void {
    this.chosenUser != ''
      ? this.selectedUSer(this.chosenUser)
      : this.userLoggedCreate();
  }

  check_path() {
    if (this.router.url === '/secure/dashboard/competenze') {
      this.enableDragDrop = false;
    }
  }

  selectWeeks(event: string) {
    this.week = event;
    this.start_week.emit(this.week.start_date);
    this.end_week.emit(this.week.end_date);
  }

  selectMonths(event: any) {
    this.selectedMonth = event.value;
    this.selectedMonthName = event.viewValue;
    this.week.start_date = '';
    this.week.end_date = '';

    this.month.emit(this.selectedMonth);
    this.start_week.emit(this.week.start_date);
    this.end_week.emit(this.week.end_date);

    if (!this.enableDragDrop) {
      return;
    } else {
      this.all_weeks_in_month();
    }
  }

  checkClear(tab?: any) {
    if (!this.isClearBS.value) {
      Swal.fire({
        text: 'Hai modifiche non salvate. Sei sicuro di voler confermare?',
        showCancelButton: true,
        cancelButtonText: 'Annulla',
        cancelButtonColor: '#00337C',
        showConfirmButton: true,
        confirmButtonText: 'Conferma',
        confirmButtonColor: '#FFB26B',
        reverseButtons: true,
        customClass: {
          popup: 'main-font'
        },
        backdrop: '#f4f3efad',
        position: 'center',
        target: '.mat-card-content',
        width: '550px'
      }).then(result => {
        // Se l'utente conferma, gestisci le modifiche non salvate
        if (result.isConfirmed) {
          if (tab.value) this.selectMonths(tab);
          this.isClearBS.next(true);
          this.resetGuard();
        }
      });
    } else if (tab?.value) this.selectMonths(tab);
  }

  selectYears(event: string) {
    this.selectedMonth = '';
    this.selectedYear = event;

    this.week.start_date = '';
    this.week.end_date = '';
    this.month.emit(this.selectedMonth);
    this.year.emit(this.selectedYear);
    this.start_week.emit(this.week.start_date);
    this.end_week.emit(this.week.end_date);
  }

  all_weeks_in_month() {
    this.timelineService
      .all_weeks_in_month(
        this.selectedYear,
        this.selectedMonth,
        this.chosenUser
      )
      .subscribe({
        next: res => (this.data = res)
      });
  }

  current_date() {
    this.timelineService.current_date().subscribe({
      next: res => {
        this.data = res;
        this.week = this.data.current_week;
        this.currentYear = this.data.current_year;
        this.selectedYear = this.data.current_year;

        this.selectedMonth = this.data.current_month;
        this.selectedMonthName = this.months.find(
          (month: any) => month.value == this.data.current_month
        )?.viewValue;
        this.currentMonth = this.data.current_month;

        this.week.start_date = this.data.current_week.start_date;
        this.week.end_date = this.data.current_week.end_date;

        this.start_week.emit(this.week.start_date);
        this.end_week.emit(this.week.end_date);

        this.years = this.data.years;

        if (!this.enableDragDrop) {
          return;
        } else {
          this.all_weeks_in_month();
        }
      }
    });
  }

  resetGuard() {
    this.resetChanges.emit(true);
  }

  selectedUSer(user: string) {
    this.profileService.profileUser(user).subscribe({
      next: res => {
        this.user_create = new Date(res.result[0]?.hiring_date);
        this.userMonth = this.user_create.getMonth() + 1;
        this.userYear = this.user_create.getFullYear();

        this.current_date();
      }
    });
  }

  userLoggedCreate() {
    this.user_create = new Date(this.profileData?.hiring_date);
    this.userMonth = this.user_create.getMonth() + 1;
    this.userYear = this.user_create.getFullYear();
  }
}
